<script setup lang="ts">
/**
 *
 *  Props and emits section
 *
 *
 */

/**
 *
 *  Ref, computed and hooks section
 *
 *
 */
const drawerOpen = ref(false)
const styleDrawer = computed(() => {
    if (drawerOpen.value) {
        return "open-drawer-right"
    }
    return "close-drawer-right"
})

/**
 *
 *  Life cicle events
 *
 *
 */

onMounted(() => {
    document.addEventListener("keydown", function (event) {
        if (event.key === "Escape") {
            document
                .querySelector(".drawer-container-right")
                ?.classList.remove("open-drawer-right")
            document
                .querySelector(".drawer-container-right")
                ?.classList.add("close-drawer-right")

            closeDrawer()
        }
    })
})

onBeforeUnmount(() => {
    document.removeEventListener("keydown", function (event) {
        if (event.key === "Escape") {
            document
                .querySelector(".drawer-container-right")
                ?.classList.remove("open-drawer-right")
            document
                .querySelector(".drawer-container-right")
                ?.classList.add("close-drawer-right")

            closeDrawer()
        }
    })
})

watch(styleDrawer, (newValue) => {
    if (newValue === "close-drawer-right") {
        drawerOpen.value = false
    }
})

/**
 *
 *  Functions section
 *
 *
 */

const toggleDrawer = () => {
    drawerOpen.value = !drawerOpen.value
}

const closeDrawer = () => {
    if (drawerOpen.value) {
        toggleDrawer()
    }
}

defineExpose({
    toggleDrawer,
})
</script>

<template>
    <section
        :class="`drawer-container-wrapper-right ${drawerOpen ? '!tw-z-[9999999] tw-min-h-screen' : '!-tw-z-1 !tw-relative'}`"
    >
        <div :class="`drawer-container-right tw-flex tw-flex-col tw-h-[100dvh] ${styleDrawer}`">
            <div class="tw-bg-primary !tw-h-12 tw-flex tw-justify-end tw-items-center tw-px-2 tw-w-full">
                    <q-icon name="fa-solid fa-close" color="white" size="sm" @click="closeDrawer" class="tw-cursor-pointer"/>
            </div>
            <slot></slot>
        </div>
        <div
            :class="`tw-absolute tw-inset-0 tw-bg-gray-700 tw-opacity-65 ${drawerOpen ? 'tw-block' : 'tw-hidden'}`"
            @click="closeDrawer"
        ></div>
    </section>
</template>

<style>
.drawer-container-wrapper-right {
    @apply tw-absolute tw-top-0 tw-left-0 tw-right-0 tw-bottom-0 tw-max-h-screen tw-overflow-hidden tw-w-full;
}
.drawer-container-right {
    @apply tw-absolute tw-z-[9999999999] tw-top-0  tw-left-auto tw-w-[320px] tw-bottom-0 tw-h-[100dvh] tw-overflow-y-auto tw-overflow-x-hidden tw-bg-white tw-shadow-2xl tw-shadow-black tw-transition-all tw-duration-300;
}

.open-drawer-right {
    @apply !tw-right-0;
}

.close-drawer-right {
    @apply -tw-right-[320px];
}
</style>
